module.exports = __webpack_public_path__ + "static/media/26UNRWA13.2eeef151.jpg";